module.exports = __webpack_public_path__ + "img/2023-20.7ffb81ec.jpg";